function f(n, t, i, d) {
  n.length;
  for (var e = i + 1; e--; )
    if (t(n[e], e, n))
      return e;
  return -1;
}
export {
  f as default
};
